import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import StyleGuide from "../pages/style-guide/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/style-guide", element: <StyleGuide /> },
  { path: "/about", element: <About /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
